import { ranges } from '@/components/DatePicker';
import * as S from '@/components/HelpBanner/styled';
import { PATH } from '@/constants';
import { AccountPlan } from '@/constants/enum';
import { capitalizeWords, handleOpenChat, isLockFeature } from '@/helpers';
import { formatAnalyticsTooltipTitle } from '@/helpers/time';
import { EShipmentType } from '@/pages/Shipments/config';
import { useGetAnalyticsFulfillmentPerformanceQuery, useLazyGetAnalyticsDeliveryTimeByCityQuery } from '@/redux/api/api.caller';
import { tokenSelector } from '@/redux/features/auth.slice';
import { setPermanentDismissId } from '@/redux/features/common.slice';
import shipmentSlice, { initialStateFilter } from '@/redux/features/shipment.slice';
import { RootState } from '@/redux/store';
import {
  Badge,
  Banner,
  BlockStack,
  Box,
  Button,
  Card,
  Icon,
  InlineGrid,
  InlineStack,
  ProgressBar,
  SkeletonBodyText,
  SkeletonDisplayText,
  Text,
  Tooltip,
} from '@shopify/polaris';
import { CheckIcon, DeliveryIcon, PackageFulfilledIcon, ReceiptIcon, RefreshIcon, XIcon } from '@shopify/polaris-icons';
import { BarChart, DataSeries, LineChart } from '@shopify/polaris-viz';
import { Tone } from '@shopify/polaris/build/ts/src/components/Badge';
import { memo, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useUpgradeTracking } from '@/hooks/useUpgradeTracking';
import * as Styled from './styled';

const CustomIcon = memo(function CustomIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={60} height={60} viewBox="0 0 60 60" fill="none">
      <g clipPath="url(#clip0_3367_11410)">
        <path
          d="M12 35.25C12.3245 35.4936 12.7193 35.6252 13.125 35.6252C13.5307 35.6252 13.9255 35.4936 14.25 35.25C14.7403 34.8825 26.25 26.1 26.25 13.125C26.25 9.64404 24.8672 6.30564 22.4058 3.84423C19.9444 1.38281 16.606 4.63278e-06 13.125 4.63278e-06C9.64403 4.63278e-06 6.30564 1.38281 3.84422 3.84423C1.38281 6.30564 0 9.64404 0 13.125C0 26.1 11.5097 34.8825 12 35.25ZM13.125 3.75C15.6106 3.75273 17.9935 4.74133 19.7511 6.49889C21.5087 8.25646 22.4973 10.6394 22.5 13.125C22.5 21.9966 15.8306 28.875 13.1222 31.3031C10.41 28.8816 3.75 22.0275 3.75 13.125C3.75273 10.6394 4.74133 8.25646 6.49889 6.49889C8.25645 4.74133 10.6394 3.75273 13.125 3.75ZM13.125 16.875C12.3833 16.875 11.6583 16.6551 11.0416 16.243C10.4249 15.831 9.94428 15.2453 9.66045 14.5601C9.37662 13.8748 9.30236 13.1208 9.44705 12.3934C9.59175 11.666 9.9489 10.9978 10.4733 10.4734C10.9978 9.94891 11.666 9.59175 12.3934 9.44706C13.1208 9.30236 13.8748 9.37663 14.5601 9.66046C15.2453 9.94428 15.831 10.4249 16.243 11.0416C16.6551 11.6583 16.875 12.3833 16.875 13.125C16.875 14.1196 16.4799 15.0734 15.7766 15.7767C15.0734 16.4799 14.1196 16.875 13.125 16.875ZM49.6875 20.625C51.7271 20.625 53.7209 20.0202 55.4168 18.887C57.1127 17.7539 58.4345 16.1433 59.215 14.2589C59.9955 12.3746 60.1998 10.3011 59.8018 8.30064C59.4039 6.30021 58.4218 4.4627 56.9795 3.02047C55.5373 1.57824 53.6998 0.596067 51.6994 0.198156C49.6989 -0.199754 47.6254 0.00446828 45.7411 0.784997C43.8567 1.56553 42.2461 2.8873 41.113 4.58319C39.9798 6.27907 39.375 8.27288 39.375 10.3125C39.378 13.0466 40.4654 15.6679 42.3988 17.6013C44.3321 19.5346 46.9534 20.622 49.6875 20.625ZM49.6875 3.75C50.9854 3.75 52.2542 4.13489 53.3334 4.85599C54.4126 5.57708 55.2538 6.602 55.7505 7.80114C56.2472 9.00028 56.3771 10.3198 56.1239 11.5928C55.8707 12.8658 55.2457 14.0351 54.3279 14.9529C53.4101 15.8707 52.2408 16.4957 50.9678 16.7489C49.6948 17.0021 48.3753 16.8722 47.1761 16.3755C45.977 15.8788 44.9521 15.0376 44.231 13.9584C43.5099 12.8792 43.125 11.6104 43.125 10.3125C43.127 8.57263 43.819 6.90459 45.0493 5.67431C46.2796 4.44403 47.9476 3.75199 49.6875 3.75ZM46.875 30H41.25V24.375C41.2483 22.8837 40.6551 21.454 39.6006 20.3994C38.546 19.3449 37.1163 18.7517 35.625 18.75H30.9375C30.4402 18.75 29.9633 18.9475 29.6117 19.2992C29.26 19.6508 29.0625 20.1277 29.0625 20.625C29.0625 21.1223 29.26 21.5992 29.6117 21.9508C29.9633 22.3025 30.4402 22.5 30.9375 22.5H35.625C36.1221 22.5005 36.5988 22.6982 36.9503 23.0497C37.3018 23.4013 37.4995 23.8779 37.5 24.375V48.75H26.9409C26.5276 47.1403 25.5905 45.7138 24.2773 44.6952C22.9641 43.6766 21.3494 43.1238 19.6875 43.1238C18.0256 43.1238 16.4109 43.6766 15.0977 44.6952C13.7845 45.7138 12.8474 47.1403 12.4341 48.75H9.375C8.87787 48.7495 8.40125 48.5518 8.04972 48.2003C7.6982 47.8488 7.5005 47.3721 7.5 46.875V37.5C7.5 37.0027 7.30246 36.5258 6.95083 36.1742C6.59919 35.8225 6.12228 35.625 5.625 35.625C5.12772 35.625 4.65081 35.8225 4.29917 36.1742C3.94754 36.5258 3.75 37.0027 3.75 37.5V46.875C3.75174 48.3663 4.34493 49.796 5.39944 50.8506C6.45396 51.9051 7.88369 52.4983 9.375 52.5H12.4341C12.8111 53.9529 13.6155 55.2592 14.7431 56.25H1.875C1.37772 56.25 0.900806 56.4475 0.549175 56.7992C0.197544 57.1508 0 57.6277 0 58.125C0 58.6223 0.197544 59.0992 0.549175 59.4508C0.900806 59.8025 1.37772 60 1.875 60H58.125C58.6223 60 59.0992 59.8025 59.4508 59.4508C59.8025 59.0992 60 58.6223 60 58.125C60 57.6277 59.8025 57.1508 59.4508 56.7992C59.0992 56.4475 58.6223 56.25 58.125 56.25H49.9444C51.072 55.2592 51.8764 53.9529 52.2534 52.5H54.375C55.8663 52.4983 57.296 51.9051 58.3506 50.8506C59.4051 49.796 59.9983 48.3663 60 46.875V43.125C59.996 39.6453 58.6119 36.3092 56.1514 33.8486C53.6908 31.3881 50.3547 30.004 46.875 30ZM19.6875 46.875C20.4292 46.875 21.1542 47.0949 21.7709 47.507C22.3876 47.919 22.8682 48.5047 23.152 49.1899C23.4359 49.8752 23.5101 50.6292 23.3654 51.3566C23.2208 52.084 22.8636 52.7522 22.3391 53.2767C21.8147 53.8011 21.1465 54.1583 20.4191 54.3029C19.6917 54.4476 18.9377 54.3734 18.2524 54.0896C17.5672 53.8057 16.9815 53.3251 16.5695 52.7084C16.1574 52.0917 15.9375 51.3667 15.9375 50.625C15.9385 49.6307 16.3339 48.6775 17.0369 47.9744C17.74 47.2714 18.6932 46.876 19.6875 46.875ZM24.6319 56.25C25.7595 55.2592 26.5639 53.9529 26.9409 52.5H37.7466C38.1236 53.9529 38.928 55.2592 40.0556 56.25H24.6319ZM41.25 50.625C41.25 49.8833 41.4699 49.1583 41.882 48.5416C42.294 47.9249 42.8797 47.4443 43.5649 47.1605C44.2502 46.8766 45.0042 46.8024 45.7316 46.9471C46.459 47.0918 47.1272 47.4489 47.6516 47.9734C48.1761 48.4978 48.5332 49.166 48.6779 49.8934C48.8226 50.6208 48.7484 51.3748 48.4646 52.0601C48.1807 52.7453 47.7001 53.331 47.0834 53.743C46.4667 54.1551 45.7417 54.375 45 54.375C44.0057 54.374 43.0525 53.9786 42.3494 53.2756C41.6464 52.5725 41.251 51.6193 41.25 50.625ZM56.25 46.875C56.2495 47.3721 56.0518 47.8488 55.7003 48.2003C55.3488 48.5518 54.8721 48.7495 54.375 48.75H52.2534C51.9674 47.6296 51.4254 46.5909 50.6699 45.7155C49.9144 44.84 48.9662 44.1518 47.8997 43.705C46.8332 43.2581 45.6776 43.0648 44.5238 43.1401C43.3699 43.2155 42.2493 43.5576 41.25 44.1394V33.75H46.875C49.3606 33.7527 51.7435 34.7413 53.5011 36.4989C55.2587 38.2565 56.2473 40.6394 56.25 43.125V46.875ZM47.8125 10.3125V7.5C47.8125 7.00272 48.01 6.52581 48.3617 6.17418C48.7133 5.82255 49.1902 5.625 49.6875 5.625C50.1848 5.625 50.6617 5.82255 51.0133 6.17418C51.365 6.52581 51.5625 7.00272 51.5625 7.5V9.30938L53.5406 10.6275C53.7455 10.7642 53.9214 10.9398 54.0584 11.1445C54.1954 11.3491 54.2907 11.5788 54.3389 11.8203C54.3871 12.0617 54.3873 12.3104 54.3395 12.5519C54.2916 12.7935 54.1967 13.0233 54.06 13.2281C53.9233 13.433 53.7477 13.6089 53.543 13.7459C53.3384 13.8829 53.1087 13.9782 52.8673 14.0264C52.6258 14.0747 52.3771 14.0748 52.1356 14.027C51.894 13.9791 51.6642 13.8842 51.4594 13.7475L48.6469 11.8725C48.3902 11.7012 48.1797 11.4692 48.0341 11.1971C47.8886 10.925 47.8125 10.6211 47.8125 10.3125Z"
          fill="url(#paint0_linear_3367_11410)"
        />
        <path
          d="M12 35.25C12.3245 35.4936 12.7193 35.6252 13.125 35.6252C13.5307 35.6252 13.9255 35.4936 14.25 35.25C14.7403 34.8825 26.25 26.1 26.25 13.125C26.25 9.64404 24.8672 6.30564 22.4058 3.84423C19.9444 1.38281 16.606 4.63278e-06 13.125 4.63278e-06C9.64403 4.63278e-06 6.30564 1.38281 3.84422 3.84423C1.38281 6.30564 0 9.64404 0 13.125C0 26.1 11.5097 34.8825 12 35.25ZM13.125 3.75C15.6106 3.75273 17.9935 4.74133 19.7511 6.49889C21.5087 8.25646 22.4973 10.6394 22.5 13.125C22.5 21.9966 15.8306 28.875 13.1222 31.3031C10.41 28.8816 3.75 22.0275 3.75 13.125C3.75273 10.6394 4.74133 8.25646 6.49889 6.49889C8.25645 4.74133 10.6394 3.75273 13.125 3.75ZM13.125 16.875C12.3833 16.875 11.6583 16.6551 11.0416 16.243C10.4249 15.831 9.94428 15.2453 9.66045 14.5601C9.37662 13.8748 9.30236 13.1208 9.44705 12.3934C9.59175 11.666 9.9489 10.9978 10.4733 10.4734C10.9978 9.94891 11.666 9.59175 12.3934 9.44706C13.1208 9.30236 13.8748 9.37663 14.5601 9.66046C15.2453 9.94428 15.831 10.4249 16.243 11.0416C16.6551 11.6583 16.875 12.3833 16.875 13.125C16.875 14.1196 16.4799 15.0734 15.7766 15.7767C15.0734 16.4799 14.1196 16.875 13.125 16.875ZM49.6875 20.625C51.7271 20.625 53.7209 20.0202 55.4168 18.887C57.1127 17.7539 58.4345 16.1433 59.215 14.2589C59.9955 12.3746 60.1998 10.3011 59.8018 8.30064C59.4039 6.30021 58.4218 4.4627 56.9795 3.02047C55.5373 1.57824 53.6998 0.596067 51.6994 0.198156C49.6989 -0.199754 47.6254 0.00446828 45.7411 0.784997C43.8567 1.56553 42.2461 2.8873 41.113 4.58319C39.9798 6.27907 39.375 8.27288 39.375 10.3125C39.378 13.0466 40.4654 15.6679 42.3988 17.6013C44.3321 19.5346 46.9534 20.622 49.6875 20.625ZM49.6875 3.75C50.9854 3.75 52.2542 4.13489 53.3334 4.85599C54.4126 5.57708 55.2538 6.602 55.7505 7.80114C56.2472 9.00028 56.3771 10.3198 56.1239 11.5928C55.8707 12.8658 55.2457 14.0351 54.3279 14.9529C53.4101 15.8707 52.2408 16.4957 50.9678 16.7489C49.6948 17.0021 48.3753 16.8722 47.1761 16.3755C45.977 15.8788 44.9521 15.0376 44.231 13.9584C43.5099 12.8792 43.125 11.6104 43.125 10.3125C43.127 8.57263 43.819 6.90459 45.0493 5.67431C46.2796 4.44403 47.9476 3.75199 49.6875 3.75ZM46.875 30H41.25V24.375C41.2483 22.8837 40.6551 21.454 39.6006 20.3994C38.546 19.3449 37.1163 18.7517 35.625 18.75H30.9375C30.4402 18.75 29.9633 18.9475 29.6117 19.2992C29.26 19.6508 29.0625 20.1277 29.0625 20.625C29.0625 21.1223 29.26 21.5992 29.6117 21.9508C29.9633 22.3025 30.4402 22.5 30.9375 22.5H35.625C36.1221 22.5005 36.5988 22.6982 36.9503 23.0497C37.3018 23.4013 37.4995 23.8779 37.5 24.375V48.75H26.9409C26.5276 47.1403 25.5905 45.7138 24.2773 44.6952C22.9641 43.6766 21.3494 43.1238 19.6875 43.1238C18.0256 43.1238 16.4109 43.6766 15.0977 44.6952C13.7845 45.7138 12.8474 47.1403 12.4341 48.75H9.375C8.87787 48.7495 8.40125 48.5518 8.04972 48.2003C7.6982 47.8488 7.5005 47.3721 7.5 46.875V37.5C7.5 37.0027 7.30246 36.5258 6.95083 36.1742C6.59919 35.8225 6.12228 35.625 5.625 35.625C5.12772 35.625 4.65081 35.8225 4.29917 36.1742C3.94754 36.5258 3.75 37.0027 3.75 37.5V46.875C3.75174 48.3663 4.34493 49.796 5.39944 50.8506C6.45396 51.9051 7.88369 52.4983 9.375 52.5H12.4341C12.8111 53.9529 13.6155 55.2592 14.7431 56.25H1.875C1.37772 56.25 0.900806 56.4475 0.549175 56.7992C0.197544 57.1508 0 57.6277 0 58.125C0 58.6223 0.197544 59.0992 0.549175 59.4508C0.900806 59.8025 1.37772 60 1.875 60H58.125C58.6223 60 59.0992 59.8025 59.4508 59.4508C59.8025 59.0992 60 58.6223 60 58.125C60 57.6277 59.8025 57.1508 59.4508 56.7992C59.0992 56.4475 58.6223 56.25 58.125 56.25H49.9444C51.072 55.2592 51.8764 53.9529 52.2534 52.5H54.375C55.8663 52.4983 57.296 51.9051 58.3506 50.8506C59.4051 49.796 59.9983 48.3663 60 46.875V43.125C59.996 39.6453 58.6119 36.3092 56.1514 33.8486C53.6908 31.3881 50.3547 30.004 46.875 30ZM19.6875 46.875C20.4292 46.875 21.1542 47.0949 21.7709 47.507C22.3876 47.919 22.8682 48.5047 23.152 49.1899C23.4359 49.8752 23.5101 50.6292 23.3654 51.3566C23.2208 52.084 22.8636 52.7522 22.3391 53.2767C21.8147 53.8011 21.1465 54.1583 20.4191 54.3029C19.6917 54.4476 18.9377 54.3734 18.2524 54.0896C17.5672 53.8057 16.9815 53.3251 16.5695 52.7084C16.1574 52.0917 15.9375 51.3667 15.9375 50.625C15.9385 49.6307 16.3339 48.6775 17.0369 47.9744C17.74 47.2714 18.6932 46.876 19.6875 46.875ZM24.6319 56.25C25.7595 55.2592 26.5639 53.9529 26.9409 52.5H37.7466C38.1236 53.9529 38.928 55.2592 40.0556 56.25H24.6319ZM41.25 50.625C41.25 49.8833 41.4699 49.1583 41.882 48.5416C42.294 47.9249 42.8797 47.4443 43.5649 47.1605C44.2502 46.8766 45.0042 46.8024 45.7316 46.9471C46.459 47.0918 47.1272 47.4489 47.6516 47.9734C48.1761 48.4978 48.5332 49.166 48.6779 49.8934C48.8226 50.6208 48.7484 51.3748 48.4646 52.0601C48.1807 52.7453 47.7001 53.331 47.0834 53.743C46.4667 54.1551 45.7417 54.375 45 54.375C44.0057 54.374 43.0525 53.9786 42.3494 53.2756C41.6464 52.5725 41.251 51.6193 41.25 50.625ZM56.25 46.875C56.2495 47.3721 56.0518 47.8488 55.7003 48.2003C55.3488 48.5518 54.8721 48.7495 54.375 48.75H52.2534C51.9674 47.6296 51.4254 46.5909 50.6699 45.7155C49.9144 44.84 48.9662 44.1518 47.8997 43.705C46.8332 43.2581 45.6776 43.0648 44.5238 43.1401C43.3699 43.2155 42.2493 43.5576 41.25 44.1394V33.75H46.875C49.3606 33.7527 51.7435 34.7413 53.5011 36.4989C55.2587 38.2565 56.2473 40.6394 56.25 43.125V46.875ZM47.8125 10.3125V7.5C47.8125 7.00272 48.01 6.52581 48.3617 6.17418C48.7133 5.82255 49.1902 5.625 49.6875 5.625C50.1848 5.625 50.6617 5.82255 51.0133 6.17418C51.365 6.52581 51.5625 7.00272 51.5625 7.5V9.30938L53.5406 10.6275C53.7455 10.7642 53.9214 10.9398 54.0584 11.1445C54.1954 11.3491 54.2907 11.5788 54.3389 11.8203C54.3871 12.0617 54.3873 12.3104 54.3395 12.5519C54.2916 12.7935 54.1967 13.0233 54.06 13.2281C53.9233 13.433 53.7477 13.6089 53.543 13.7459C53.3384 13.8829 53.1087 13.9782 52.8673 14.0264C52.6258 14.0747 52.3771 14.0748 52.1356 14.027C51.894 13.9791 51.6642 13.8842 51.4594 13.7475L48.6469 11.8725C48.3902 11.7012 48.1797 11.4692 48.0341 11.1971C47.8886 10.925 47.8125 10.6211 47.8125 10.3125Z"
          fill="url(#paint1_linear_3367_11410)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3367_11410"
          x1="50.3859"
          y1="-1.18969"
          x2="11.6372"
          y2="65.9269"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EA5A6B" />
          <stop offset="0.181" stopColor="#B9569B" />
          <stop offset="0.351" stopColor="#9052C1" />
          <stop offset="0.439" stopColor="#8151D0" />
          <stop offset="0.483" stopColor="#7D51D4" />
          <stop offset="0.806" stopColor="#634FED" />
          <stop offset={1} stopColor="#5A4EF6" />
        </linearGradient>
        <linearGradient id="paint1_linear_3367_11410" x1={30} y1={60} x2={30} y2={0} gradientUnits="userSpaceOnUse">
          <stop stopColor="#3A89FF" />
          <stop offset={1} stopColor="#81CFFF" />
        </linearGradient>
        <clipPath id="clip0_3367_11410">
          <rect width={60} height={60} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});

// Constants
const BANNER_ID_SUFFIX = '59438431-b086-4dfb-bd45-a84fcdcdb518';
const SAMPLE_DATA_PLANS = [AccountPlan.Starter, AccountPlan.Basic];

const DEFAULT_ANALYTICS_DATA = {
  data: {
    metrics: {
      averageProcessingTime: 0,
      averageProcessingTimeChange: 0,
      averageProcessingTimeChangeDays: 0,
      averageDispatchLeadTime: 0,
      averageDispatchLeadTimeChange: 0,
      averageDispatchLeadTimeChangeDays: 0,
      dispatchLeadTimeP90: 0,
      dispatchLeadTimeP90Change: 0,
      dispatchLeadTimeP90ChangeDays: 0,
      slowDispatchedShipments: 0,
      slowDispatchedShipmentsPercentage: 0,
      averageDeliveryTime: 0,
      averageDeliveryTimeChange: 0,
      averageDeliveryTimeChangeDays: 0,
      averageOrderToDeliveryTime: 0,
      averageOrderToDeliveryTimeChange: 0,
      averageOrderToDeliveryTimeChangeDays: 0,
    },
    processingTimeChart: {
      categories: ['01-01', '01-02', '01-03', '01-04', '01-05'],
      series: [0, 0, 0, 0, 0],
    },
    dispatchLeadTimeChart: {
      categories: ['01-01', '01-02', '01-03', '01-04', '01-05'],
      series: [0, 0, 0, 0, 0],
    },
    dispatchLeadTimeP90Chart: {
      categories: ['01-01', '01-02', '01-03', '01-04', '01-05'],
      series: [0, 0, 0, 0, 0],
    },
    deliveryTimeChart: {
      categories: ['01-01', '01-02', '01-03', '01-04', '01-05'],
      series: [0, 0, 0, 0, 0],
    },
    orderToDeliveryChart: {
      categories: ['01-01', '01-02', '01-03', '01-04', '01-05'],
      series: [0, 0, 0, 0, 0],
    },
    deliveryTimeByCarrierChart: {
      categories: ['01-01', '01-02', '01-03', '01-04', '01-05'],
      series: [0, 0, 0, 0, 0],
    },
    deliveryTimeByLocationChart: {
      categories: [],
      series: [],
      counts: [],
    },
  },
};

const BANNER_FIRST_COLUMN_ITEMS = [
  {
    id: '1',
    label: 'How fast your orders move from creation to delivery',
    showBullet: true,
  },
  {
    id: '2',
    label: 'Which stage of fulfillment takes the most time (processing, dispatch, or delivery)',
    showBullet: true,
  },
];

interface FulfillmentPerformanceProps {
  start: Date;
  end: Date;
  title: string;
}

const FulfillmentPerformance = ({ start, end, title }: FulfillmentPerformanceProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { navigateToPlan } = useUpgradeTracking();
  const { shop } = useSelector(tokenSelector);
  const id = `${shop}:${BANNER_ID_SUFFIX}`;
  const { permanentDismissIds } = useSelector((state: RootState) => state.common);
  const isLock = isLockFeature(SAMPLE_DATA_PLANS);
  const { data, isLoading, refetch } = useGetAnalyticsFulfillmentPerformanceQuery({
    fromDate: start.toISOString(),
    toDate: end.toISOString(),
    dateType: ranges.find((range) => range.title === title)?.alias,
  });

  // Manual refresh state management
  const [isPollingLoading, setIsPollingLoading] = useState(false);
  const [pollingProgress, setPollingProgress] = useState<number>(0);
  const [showRefreshButton, setShowRefreshButton] = useState(false);
  const [canRefresh, setCanRefresh] = useState(true);
  const autoIncrementRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const showRefreshTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // Auto-increment progress visually while processing
  useEffect(() => {
    if (isPollingLoading) {
      autoIncrementRef.current = setInterval(() => {
        setPollingProgress((prev) => {
          if (prev >= 95) return prev; // cap at 95 — real completion snaps to 100
          const step = prev < 30 ? 0.8 : prev < 60 ? 0.4 : 0.15; // slow down as it approaches cap
          return Math.min(prev + step, 95);
        });
      }, 600);
    } else {
      if (autoIncrementRef.current) clearInterval(autoIncrementRef.current);
    }
    return () => {
      if (autoIncrementRef.current) clearInterval(autoIncrementRef.current);
    };
  }, [isPollingLoading]);

  // Derive processing state directly from data to avoid one-render flash
  // (isPollingLoading updates async via useEffect, causing a brief flash before skeletons appear)
  const isCurrentlyProcessing = !isLoading && data?.data?.state === 'processing';
  const finalData = isLoading || isCurrentlyProcessing ? DEFAULT_ANALYTICS_DATA : data;
  const finalIsLoading = isLoading || isCurrentlyProcessing;

  // Sync polling state with the latest response state
  useEffect(() => {
    if (!data?.data) return;

    if (data.data.state === 'processing') {
      setIsPollingLoading(true);
      setPollingProgress(data.data.progress || 1);
      showRefreshTimeoutRef.current = setTimeout(() => setShowRefreshButton(true), 2000);
    } else {
      if (showRefreshTimeoutRef.current) clearTimeout(showRefreshTimeoutRef.current);
      setIsPollingLoading(false);
      setShowRefreshButton(false);
      setPollingProgress(0);
    }
  }, [data]);

  // Manual check job status — refetch the main endpoint to get updated state/progress
  const checkJobStatus = async () => {
    setCanRefresh(false);
    try {
      await refetch();
    } finally {
      setCanRefresh(true);
    }
  };

  const summaryMetrics = useMemo(() => {
    const metrics = finalData?.data.metrics;
    return {
      averageProcessingTime: metrics?.averageProcessingTime || 0,
      averageProcessingTimeChange: metrics?.averageProcessingTimeChange || 0,
      averageProcessingTimeChangeDays: metrics?.averageProcessingTimeChangeDays || 0,

      averageDispatchLeadTime: metrics?.averageDispatchLeadTime || 0,
      averageDispatchLeadTimeChange: metrics?.averageDispatchLeadTimeChange || 0,
      averageDispatchLeadTimeChangeDays: metrics?.averageDispatchLeadTimeChangeDays || 0,

      dispatchLeadTimeP90: metrics?.dispatchLeadTimeP90 || 0,
      dispatchLeadTimeP90Change: metrics?.dispatchLeadTimeP90Change || 0,
      dispatchLeadTimeP90ChangeDays: metrics?.dispatchLeadTimeP90ChangeDays || 0,

      slowDispatchedShipments: metrics?.slowDispatchedShipments || 0,
      slowDispatchedShipmentsPercentage: metrics?.slowDispatchedShipmentsPercentage || 0,

      averageDeliveryTime: metrics?.averageDeliveryTime || 0,
      averageDeliveryTimeChange: metrics?.averageDeliveryTimeChange || 0,
      averageDeliveryTimeChangeDays: metrics?.averageDeliveryTimeChangeDays || 0,

      averageOrderToDeliveryTime: metrics?.averageOrderToDeliveryTime || 0,
      averageOrderToDeliveryTimeChange: metrics?.averageOrderToDeliveryTimeChange || 0,
      averageOrderToDeliveryTimeChangeDays: metrics?.averageOrderToDeliveryTimeChangeDays || 0,
    };
  }, [finalData]);

  const avgProcessingTimeData: DataSeries[] = useMemo(() => {
    const processingTimeChart = finalData?.data?.processingTimeChart;
    if (!processingTimeChart || !processingTimeChart.categories || !processingTimeChart.series) return [];
    const { categories, series } = processingTimeChart;
    return [
      {
        name: 'Daily average',
        data: categories.map((category: any, index: number) => {
          return { key: category, value: Number(series[index] || 0) };
        }),
        color: '#2196F3',
      },
    ];
  }, [finalData]);

  const avgDispatchLeadTimeData: DataSeries[] = useMemo(() => {
    const dispatchLeadTimeChart = finalData?.data?.dispatchLeadTimeChart;
    if (!dispatchLeadTimeChart || !dispatchLeadTimeChart.categories || !dispatchLeadTimeChart.series) return [];
    const { categories, series } = dispatchLeadTimeChart;
    return [
      {
        name: 'Daily average',
        data: categories.map((category: any, index: number) => {
          return { key: category, value: Number(series[index] || 0) };
        }),
        color: '#2196F3',
      },
    ];
  }, [finalData]);

  const dispatchLeadTimeData: DataSeries[] = useMemo(() => {
    const dispatchLeadTimeP90Chart = finalData?.data?.dispatchLeadTimeP90Chart;
    if (!dispatchLeadTimeP90Chart || !dispatchLeadTimeP90Chart.categories || !dispatchLeadTimeP90Chart.series) return [];
    const { categories, series } = dispatchLeadTimeP90Chart;
    return [
      {
        name: 'Daily average',
        data: categories.map((category: any, index: number) => {
          return { key: category, value: Number(series[index] || 0) };
        }),
        color: '#2196F3',
      },
    ];
  }, [finalData]);

  const avgDeliveryTimeData: DataSeries[] = useMemo(() => {
    const deliveryTimeChart = finalData?.data?.deliveryTimeChart;
    if (!deliveryTimeChart || !deliveryTimeChart.categories || !deliveryTimeChart.series) return [];
    const { categories, series } = deliveryTimeChart;
    return [
      {
        name: 'Daily average',
        data: categories.map((category: any, index: number) => {
          return { key: category, value: Number(series[index] || 0) };
        }),
        color: '#2196F3',
      },
    ];
  }, [finalData]);

  const avgOrderToDeliveryData: DataSeries[] = useMemo(() => {
    const orderToDeliveryChart = finalData?.data?.orderToDeliveryChart;
    if (!orderToDeliveryChart || !orderToDeliveryChart.categories || !orderToDeliveryChart.series) return [];
    const { categories, series } = orderToDeliveryChart;
    return [
      {
        name: 'Daily average',
        data: categories.map((category: any, index: number) => {
          return { key: category, value: Number(series[index] || 0) };
        }),
        color: '#2196F3',
      },
    ];
  }, [finalData]);

  const avgDeliveryByCarrierData: DataSeries[] = useMemo(() => {
    const deliveryTimeByCarrierChart = finalData?.data?.deliveryTimeByCarrierChart;
    if (!deliveryTimeByCarrierChart || !deliveryTimeByCarrierChart.categories || !deliveryTimeByCarrierChart.series) return [];
    const { categories, series } = deliveryTimeByCarrierChart;
    return [
      {
        name: 'Carrier',
        data: categories.map((category: any, index: number) => {
          return { key: capitalizeWords(category), value: Number(series[index] || 0) };
        }),
        color: '#2196F3',
      },
    ];
  }, [finalData]);

  const avgDeliveryByLocationData: DataSeries[] = useMemo(() => {
    const chart = finalData?.data?.deliveryTimeByLocationChart;
    if (!chart || !chart.categories || !chart.series) return [];
    const { categories, series, counts } = chart;
    return [
      {
        name: 'Country',
        data: categories.map((category: string, index: number) => ({
          key: `${category} (${counts?.[index] ?? 0})`,
          value: Number(series[index] || 0),
        })),
        color: '#4CAF50',
      },
    ];
  }, [finalData]);

  const [selectedCountry, setSelectedCountry] = useState<string | null>(null);
  const [fetchDeliveryTimeByCity, { data: cityData, isFetching: isCityLoading }] = useLazyGetAnalyticsDeliveryTimeByCityQuery();

  // Reset city drill-down when date filter changes
  useEffect(() => {
    setSelectedCountry(null);
  }, [start, end, title]);

  const cityChartData: DataSeries[] = useMemo(() => {
    const chart = cityData?.data;
    if (!chart || !chart.categories || !chart.series) return [];
    const { categories, series, counts } = chart;
    return [
      {
        name: 'City',
        data: categories.map((category: string, index: number) => ({
          key: `${category} (${counts?.[index] ?? 0})`,
          value: Number(series[index] || 0),
        })),
        color: '#FF9800',
      },
    ];
  }, [cityData]);

  const handleCountryClick = (country: string) => {
    setSelectedCountry(country);
    fetchDeliveryTimeByCity({
      fromDate: start.toISOString(),
      toDate: end.toISOString(),
      dateType: ranges.find((range) => range.title === title)?.alias,
      country,
    });
  };

  // Calculate chart states
  const getChartState = (dataLength: number): any => {
    if (finalIsLoading) return 'Loading';
    // if (dataLength === 0) return 'Error';
    return 'Success';
  };

  const getToneOfSummaryMetrics = (metrics: number): Tone | undefined => {
    switch (true) {
      case metrics < 0:
        return 'success';
      case metrics > 0:
        return 'critical';
      case metrics === 0:
        return 'info';
      default:
        return undefined;
    }
  };

  const getTitleOfSummaryMetrics = (daysChange: number, percentChange: number): string => {
    const formattedDays = daysChange > 0 ? `+${daysChange}` : `${daysChange}`;

    const formattedPercent = percentChange > 0 ? `+${percentChange}` : `${percentChange}`;

    return `${formattedDays} days (${formattedPercent}%)`;
  };

  const formatTooltipTitle = (title: string): string => {
    return formatAnalyticsTooltipTitle(title);
  };

  const handleRefreshClick = () => {
    checkJobStatus();
  };

  return (
    <Styled.StyledFulfillmentPerformance>
      {/* Refresh Button */}
      {showRefreshButton && data?.data?.state === 'processing' && (
        <Box background="bg-surface-secondary" borderRadius="300" padding="400" borderWidth="025" borderColor="border">
          <BlockStack gap="300">
            <InlineStack align="space-between" blockAlign="center">
              <BlockStack gap="050">
                <Text as="p" variant="bodyMd" fontWeight="semibold">
                  Data is being calculated
                </Text>
                <Text as="p" variant="bodySm" tone="subdued">
                  Your analytics are being processed in the background.
                </Text>
              </BlockStack>
              <Button icon={RefreshIcon} onClick={handleRefreshClick} loading={!canRefresh} variant="primary" size="slim">
                Check status
              </Button>
            </InlineStack>
            <ProgressBar progress={pollingProgress} size="small" tone="primary" animated />
          </BlockStack>
        </Box>
      )}

      {isLock && (
        <Banner tone="info">
          <InlineStack>
            This is SAMPLE data set. Upgrade to Scale plan or above to unlock your insights.
            <Button
              variant="primary"
              onClick={() => navigateToPlan({
                trigger_type: 'banner',
                trigger_element: 'Upgrade Now',
                feature: 'fulfillment_performance',
              })}
            >
              Upgrade Now
            </Button>
          </InlineStack>
        </Banner>
      )}
      {/* Summary Cards */}
      <div className="summary-section">
        {/* Info Banner */}
        {!permanentDismissIds.includes(id) && (
          <S.BannerContainer>
            <S.BannerContent>
              <S.Content $justifyContent="flex-start" $gap="60px" $gapResponsive="16px">
                <InlineStack gap="800" blockAlign="center" wrap={false}>
                  <S.IconWrapper>
                    <CustomIcon />
                  </S.IconWrapper>
                  <BlockStack gap="200">
                    <Text as="p" variant="bodyMd" tone="subdued">
                      What to look for
                    </Text>
                    <Text as="p" variant="bodyLg" fontWeight="semibold">
                      Diagnose fulfillment bottlenecks
                    </Text>
                  </BlockStack>
                </InlineStack>

                {BANNER_FIRST_COLUMN_ITEMS.length > 0 && (
                  <BlockStack gap="200">
                    {BANNER_FIRST_COLUMN_ITEMS.map((item) => (
                      <S.ListItem key={item.id}>
                        {item.showBullet !== false && <S.Bullet>•</S.Bullet>}
                        <Text as="span" variant="bodyMd">
                          {item.label}
                        </Text>
                      </S.ListItem>
                    ))}
                  </BlockStack>
                )}

                <BlockStack gap="200">
                  <S.ListItem>
                    <S.Bullet>•</S.Bullet>
                    <Text as="span" variant="bodyMd" tone="subdued">
                      Not find this helpful?
                    </Text>
                  </S.ListItem>
                  <S.ListItem>
                    <Button onClick={handleOpenChat}>Feedback us</Button>
                  </S.ListItem>
                </BlockStack>
              </S.Content>

              <S.CloseButton onClick={() => dispatch(setPermanentDismissId(id))}>
                <XIcon />
              </S.CloseButton>
            </S.BannerContent>
          </S.BannerContainer>
        )}

        {/* Order-to-Delivery Time Summary */}
        <div className={`card-wrapper ${isLock ? 'locked' : ''}`}>
          <Card>
            <BlockStack gap="400">
              <Text as="h2" variant="headingMd">
                Order-to-Delivery Time Summary
              </Text>

              {finalIsLoading ? (
                <SkeletonBodyText lines={15} />
              ) : (
                <>
                  <Styled.TimelineContainer>
                    <Styled.TimelineStage>
                      <Styled.IconCircle $bgColor="#E3F2FD">
                        <Icon source={ReceiptIcon} tone="info" />
                      </Styled.IconCircle>
                      <Styled.StageLabel>Order created</Styled.StageLabel>
                    </Styled.TimelineStage>
                    <Styled.StageContent>
                      <Text as="p" variant="headingLg" fontWeight="bold">
                        {summaryMetrics.averageProcessingTime} days
                      </Text>
                      <Styled.Arrow />
                      <Text as="p" variant="bodySm" tone="subdued">
                        Avg. Processing Time
                      </Text>
                    </Styled.StageContent>
                    <Styled.TimelineStage>
                      <Styled.IconCircle $bgColor="#E3F2FD">
                        <Icon source={PackageFulfilledIcon} tone="info" />
                      </Styled.IconCircle>
                      <Styled.StageLabel>Fulfillment created</Styled.StageLabel>
                    </Styled.TimelineStage>
                    <Styled.StageContent>
                      <Text as="p" variant="headingLg" fontWeight="bold">
                        {summaryMetrics.averageDispatchLeadTime} days
                      </Text>
                      <Styled.Arrow />
                      <Text as="p" variant="bodySm" tone="subdued">
                        Avg. Dispatch Lead Time
                      </Text>
                    </Styled.StageContent>
                    <Styled.TimelineStage>
                      <Styled.IconCircle $bgColor="#E3F2FD">
                        <Icon source={DeliveryIcon} tone="info" />
                      </Styled.IconCircle>
                      <Styled.StageLabel>Handled by Carrier</Styled.StageLabel>
                    </Styled.TimelineStage>
                    <Styled.StageContent>
                      <Text as="p" variant="headingLg" fontWeight="bold">
                        {summaryMetrics.averageDeliveryTime} days
                      </Text>
                      <Styled.Arrow />
                      <Text as="p" variant="bodySm" tone="subdued">
                        Avg. Delivery Time
                      </Text>
                    </Styled.StageContent>
                    <Styled.TimelineStage>
                      <Styled.IconCircle $bgColor="#E3F2FD">
                        <Icon source={CheckIcon} tone="info" />
                      </Styled.IconCircle>
                      <Styled.StageLabel>Delivered</Styled.StageLabel>
                    </Styled.TimelineStage>
                  </Styled.TimelineContainer>

                  {/* Bottom total bar */}
                  <Styled.TotalBar>
                    <Styled.TotalContent>
                      <Text as="p" variant="headingLg" fontWeight="bold">
                        {summaryMetrics.averageOrderToDeliveryTime} days
                      </Text>
                      <Styled.TotalArrow />
                      <Text as="p" variant="bodySm" tone="subdued">
                        Avg. Order-to-Delivery Time
                      </Text>
                    </Styled.TotalContent>
                  </Styled.TotalBar>
                </>
              )}
            </BlockStack>
          </Card>
        </div>
      </div>

      {/* Charts Grid */}
      <InlineGrid columns={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 2 }} gap="400">
        {/* Average Processing Time */}
        <div className={`card-wrapper ${isLock ? 'locked' : ''}`}>
          <Card>
            <InlineStack>
              <Tooltip content="Average time between order created and order marked as fulfilled" hasUnderline dismissOnMouseOut>
                <Text as="h2" variant="headingSm">
                  Average Processing Time
                </Text>
              </Tooltip>
            </InlineStack>
            <Box paddingBlockStart="200">
              {finalIsLoading ? (
                <SkeletonDisplayText size="small" />
              ) : (
                <>
                  <Text variant="heading2xl" as="h3">
                    {summaryMetrics.averageProcessingTime}{' '}
                    <Text as="span" variant="bodyMd" tone="subdued">
                      days
                    </Text>
                  </Text>
                  <InlineStack>
                    <Badge tone={getToneOfSummaryMetrics(summaryMetrics.averageProcessingTimeChange)}>
                      {getTitleOfSummaryMetrics(
                        summaryMetrics.averageProcessingTimeChangeDays,
                        summaryMetrics.averageProcessingTimeChange,
                      )}
                    </Badge>
                  </InlineStack>
                </>
              )}
            </Box>
            <Box paddingBlockStart="600">
              <div style={{ height: '300px' }}>
                <LineChart
                  data={avgProcessingTimeData}
                  state={getChartState(avgProcessingTimeData.length)}
                  theme="Light"
                  isAnimated
                  showLegend
                  tooltipOptions={{
                    titleFormatter: (title) => formatTooltipTitle(title?.toString() || ''),
                    valueFormatter: (value) => `${value} days`,
                  }}
                />
              </div>
            </Box>
          </Card>
        </div>

        {/* Average Dispatch Lead Time */}
        <div className={`card-wrapper ${isLock ? 'locked' : ''}`}>
          <Card>
            <InlineStack>
              <Tooltip
                content="Average time between order marked as fulfilled and carrier's first scan"
                hasUnderline
                dismissOnMouseOut
              >
                <Text as="h2" variant="headingSm">
                  Average Dispatch Lead Time
                </Text>
              </Tooltip>
            </InlineStack>
            <Box paddingBlockStart="200">
              {finalIsLoading ? (
                <SkeletonDisplayText size="small" />
              ) : (
                <>
                  <Text variant="heading2xl" as="h3">
                    {summaryMetrics.averageDispatchLeadTime}{' '}
                    <Text as="span" variant="bodyMd" tone="subdued">
                      days
                    </Text>
                  </Text>
                  <InlineStack>
                    <Badge tone={getToneOfSummaryMetrics(summaryMetrics.averageDispatchLeadTimeChange)}>
                      {getTitleOfSummaryMetrics(
                        summaryMetrics.averageDispatchLeadTimeChangeDays,
                        summaryMetrics.averageDispatchLeadTimeChange,
                      )}
                    </Badge>
                  </InlineStack>
                </>
              )}
            </Box>
            <Box paddingBlockStart="600">
              <div style={{ height: '300px' }}>
                <LineChart
                  data={avgDispatchLeadTimeData}
                  state={getChartState(avgDispatchLeadTimeData.length)}
                  theme="Light"
                  isAnimated
                  showLegend
                  tooltipOptions={{
                    titleFormatter: (title) => formatTooltipTitle(title?.toString() || ''),
                    valueFormatter: (value) => `${value} days`,
                  }}
                />
              </div>
            </Box>
          </Card>
        </div>

        {/* Dispatch Lead Time */}
        <div className={`card-wrapper ${isLock ? 'locked' : ''}`}>
          <Card>
            <InlineStack>
              <Tooltip
                content="The 90th-percentile dispatch time means 90% of shipments are picked up by the carrier within this duration."
                hasUnderline
                dismissOnMouseOut
              >
                <Text as="h2" variant="headingSm">
                  Dispatch Lead Time P90
                </Text>
              </Tooltip>
            </InlineStack>
            <Box paddingBlockStart="200">
              {finalIsLoading ? (
                <SkeletonDisplayText size="small" />
              ) : (
                <>
                  <Text variant="heading2xl" as="h3">
                    {summaryMetrics.dispatchLeadTimeP90}{' '}
                    <Text as="span" variant="bodyMd" tone="subdued">
                      days
                    </Text>
                  </Text>
                  <InlineStack>
                    <Badge tone={getToneOfSummaryMetrics(summaryMetrics.dispatchLeadTimeP90Change)}>
                      {getTitleOfSummaryMetrics(
                        summaryMetrics.dispatchLeadTimeP90ChangeDays,
                        summaryMetrics.dispatchLeadTimeP90Change,
                      )}
                    </Badge>
                  </InlineStack>
                </>
              )}
            </Box>
            <Box paddingBlockStart="600">
              <div style={{ height: '300px' }}>
                <LineChart
                  data={dispatchLeadTimeData}
                  state={getChartState(dispatchLeadTimeData.length)}
                  theme="Light"
                  isAnimated
                  showLegend
                  tooltipOptions={{
                    titleFormatter: (title) => formatTooltipTitle(title?.toString() || ''),
                    valueFormatter: (value) => `${value} days`,
                  }}
                />
              </div>
            </Box>
            <Box paddingBlockStart="200">
              {finalIsLoading ? (
                <SkeletonDisplayText size="small" />
              ) : (
                <>
                  <InlineStack>
                    <Tooltip content="Count of shipments slower than Dispatch Lead Time P90." hasUnderline dismissOnMouseOut>
                      <Text as="h2" variant="headingSm">
                        Slow dispatched shipments
                      </Text>
                    </Tooltip>
                  </InlineStack>
                  <Box>
                    <Text variant="heading2xl" as="h3">
                      {summaryMetrics.slowDispatchedShipments}
                    </Text>
                    <Button
                      variant="plain"
                      onClick={() => {
                        dispatch(
                          shipmentSlice.actions.handleChangeTableFilter({
                            ...initialStateFilter,
                            type: EShipmentType.TRACKED_SHIPMENT,
                          }),
                        );
                        dispatch(shipmentSlice.actions.handleDatePicker({ start, end }));
                        dispatch(shipmentSlice.actions.handleTitleDatePicker(title));
                        setTimeout(() => {
                          navigate(`${PATH.SHIPMENT}?slow_dispatch=true`);
                        });
                      }}
                    >
                      &gt; View slow shipments
                    </Button>
                  </Box>
                </>
              )}
            </Box>
          </Card>
        </div>

        {/* Average Delivery Time */}
        <div className={`card-wrapper ${isLock ? 'locked' : ''}`}>
          <Card>
            <InlineStack>
              <Tooltip content="Average time between carrier's first scan and delivery." hasUnderline dismissOnMouseOut>
                <Text as="h2" variant="headingSm">
                  Average Delivery Time
                </Text>
              </Tooltip>
            </InlineStack>
            <Box paddingBlockStart="200">
              {finalIsLoading ? (
                <SkeletonDisplayText size="small" />
              ) : (
                <>
                  <Text variant="heading2xl" as="h3">
                    {summaryMetrics.averageDeliveryTime}{' '}
                    <Text as="span" variant="bodyMd" tone="subdued">
                      days
                    </Text>
                  </Text>
                  <InlineStack>
                    <Badge tone={getToneOfSummaryMetrics(summaryMetrics.averageDeliveryTimeChange)}>
                      {getTitleOfSummaryMetrics(
                        summaryMetrics.averageDeliveryTimeChangeDays,
                        summaryMetrics.averageDeliveryTimeChange,
                      )}
                    </Badge>
                  </InlineStack>
                </>
              )}
            </Box>
            <Box paddingBlockStart="600">
              <div style={{ height: '300px' }}>
                <LineChart
                  data={avgDeliveryTimeData}
                  state={getChartState(avgDeliveryTimeData.length)}
                  theme="Light"
                  isAnimated
                  showLegend
                  tooltipOptions={{
                    titleFormatter: (title) => formatTooltipTitle(title?.toString() || ''),
                    valueFormatter: (value) => `${value} days`,
                  }}
                />
              </div>
            </Box>
          </Card>
        </div>

        {/* Average Order-to-Delivery Time */}
        <div className={`card-wrapper ${isLock ? 'locked' : ''}`}>
          <Card>
            <InlineStack>
              <Tooltip content="Average time between order created to delivery." hasUnderline dismissOnMouseOut>
                <Text as="h2" variant="headingSm">
                  Average Order-to-Delivery Time
                </Text>
              </Tooltip>
            </InlineStack>
            <Box paddingBlockStart="200">
              {finalIsLoading ? (
                <SkeletonDisplayText size="small" />
              ) : (
                <>
                  <Text variant="heading2xl" as="h3">
                    {summaryMetrics.averageOrderToDeliveryTime}{' '}
                    <Text as="span" variant="bodyMd" tone="subdued">
                      days
                    </Text>
                  </Text>
                  <InlineStack>
                    <Badge tone={getToneOfSummaryMetrics(summaryMetrics.averageOrderToDeliveryTimeChange)}>
                      {getTitleOfSummaryMetrics(
                        summaryMetrics.averageOrderToDeliveryTimeChangeDays,
                        summaryMetrics.averageOrderToDeliveryTimeChange,
                      )}
                    </Badge>
                  </InlineStack>
                </>
              )}
            </Box>
            <Box paddingBlockStart="600">
              <div style={{ height: '300px' }}>
                <LineChart
                  data={avgOrderToDeliveryData}
                  state={getChartState(avgOrderToDeliveryData.length)}
                  theme="Light"
                  isAnimated
                  showLegend
                  tooltipOptions={{
                    titleFormatter: (title) => formatTooltipTitle(title?.toString() || ''),
                    valueFormatter: (value) => `${value} days`,
                  }}
                />
              </div>
            </Box>
          </Card>
        </div>

        {/* Average Delivery Time by Carrier - Full Width */}
        <div className={`card-wrapper ${isLock ? 'locked' : ''}`}>
          <Card>
            <Text as="h2" variant="headingSm">
              Average Delivery Time by Carrier
            </Text>
            <Box paddingBlockStart="600">
              <div style={{ height: '300px' }}>
                <BarChart
                  data={avgDeliveryByCarrierData}
                  state={getChartState(avgDeliveryByCarrierData.length)}
                  theme="Light"
                  isAnimated
                  tooltipOptions={{
                    valueFormatter: (value) => `${value} days`,
                  }}
                />
              </div>
            </Box>
          </Card>
        </div>

        {/* Average Delivery Time by Destination Country - Full Width */}
        <div className={`card-wrapper ${isLock ? 'locked' : ''}`}>
          <Card>
            <InlineStack align="space-between" blockAlign="center">
              <Text as="h2" variant="headingSm">
                Average Delivery Time by Destination
              </Text>
              {selectedCountry && (
                <Button variant="plain" onClick={() => setSelectedCountry(null)} icon={XIcon}>
                  Clear: {selectedCountry}
                </Button>
              )}
            </InlineStack>
            <Box paddingBlockStart="400">
              {/* TR-454: horizontal + height động → nhiều country vẫn đọc được từng hàng (xem spec §5) */}
              <div
                style={{
                  height: `${Math.min(600, Math.max(300, (avgDeliveryByLocationData[0]?.data?.length ?? 0) * 40))}px`,
                  overflowY: 'auto',
                }}
              >
                <BarChart
                  data={avgDeliveryByLocationData}
                  direction="horizontal"
                  state={getChartState(avgDeliveryByLocationData.length)}
                  theme="Light"
                  isAnimated
                  tooltipOptions={{
                    valueFormatter: (value) => `${value} days`,
                  }}
                />
              </div>
            </Box>

            {/* Country drill-down selector */}
            {!finalIsLoading && avgDeliveryByLocationData.length > 0 && (
              <Box paddingBlockStart="300">
                <BlockStack gap="200">
                  <Text as="p" variant="bodySm" tone="subdued">
                    Select a country to see city-level breakdown:
                  </Text>
                  <InlineStack gap="200" wrap>
                    {finalData?.data?.deliveryTimeByLocationChart?.categories?.map((country) => (
                      <Button
                        key={country}
                        size="slim"
                        pressed={selectedCountry === country}
                        onClick={() => handleCountryClick(country)}
                      >
                        {country}
                      </Button>
                    ))}
                  </InlineStack>
                </BlockStack>
              </Box>
            )}

            {/* City Drill-down */}
            {selectedCountry && (
              <Box paddingBlockStart="600">
                <BlockStack gap="300">
                  <Text as="h3" variant="headingSm">
                    {selectedCountry} — Delivery Time by City
                  </Text>
                  {/* TR-454: city breakdown — horizontal + height động theo số city + scroll.
                      Trước fix: BarChart vertical mặc định + height 250px cố định → country nhiều
                      city (vd 12) render trống/không đọc được label. Xem spec §5 + evidence/TR-454-repro.md */}
                  <div
                    style={{
                      height: `${Math.min(600, Math.max(250, (cityChartData[0]?.data?.length ?? 0) * 40))}px`,
                      overflowY: 'auto',
                    }}
                  >
                    <BarChart
                      data={cityChartData}
                      direction="horizontal"
                      state={(isCityLoading ? 'Loading' : 'Success') as any}
                      theme="Light"
                      isAnimated
                      tooltipOptions={{
                        valueFormatter: (value) => `${value} days`,
                      }}
                    />
                  </div>
                </BlockStack>
              </Box>
            )}
          </Card>
        </div>
      </InlineGrid>
    </Styled.StyledFulfillmentPerformance>
  );
};

export default FulfillmentPerformance;
